export {default} from './RankUpReport';
